import { render, staticRenderFns } from "./CreateVariablesCard.vue?vue&type=template&id=01670137&scoped=true&"
import script from "./CreateVariablesCard.vue?vue&type=script&lang=js&"
export * from "./CreateVariablesCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateVariablesCard.vue?vue&type=style&index=0&id=01670137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01670137",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
